<template>
  <polygon
    id="plus"
    :fill="iconColor"
    points="14.5 9.5 22 9.5 22 14.5 14.5 14.5 14.5 22 9.5 22 9.5 14.5 2 14.5 2 9.5 9.5 9.5 9.5 2 14.5 2"
  />
</template>

<script>
export default {
    name: 'PlusIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
